<template>
	<v-content :style="{'background-image': `url('`+ require('../assets/bg-login.jpg') +`')`}"
	           style="background-size: cover">
		<!-- Header -->
		<Header></Header>

		<!-- Menu -->
		<v-layout justify-center>
			<v-flex xs12 style="background-color: #527281">
				<v-container>
					<v-layout>
						<v-flex md3 style="text-align: left;">
							<v-btn text small style="color: white;font-size: 18px" @click="$router.push('/home').catch(err => {})">
								หน้าแรก
							</v-btn>
						</v-flex>
					</v-layout>
				</v-container>
			</v-flex>
		</v-layout>

		<!-- Form Search -->
		<v-container>
			<v-layout justify-center>
				<v-flex class="mt-2" style="font-size: 56px; font-weight: bold;color: #D97C57;">
					ค้นหา
				</v-flex>
			</v-layout>
			<v-layout justify-center>
				<v-flex style="font-size: 28px; font-weight: bold;color: #D97C57;">
					คุณลักษณะเฉพาะสิ่งอุปกรณ์สายแพทย์
				</v-flex>
			</v-layout>
			<v-layout justify-center>
				<v-flex xs12 sm10 md12 class="mb-6 mt-6">
					<v-card class="py-12" style="border-radius: 25px;background: white; box-shadow: #2c3e50">
						<v-layout justify-center>
							<v-flex xs12 class="px-2" style="font-size: 24px">
								<div class="form-search">
									<v-form>
										<v-layout justify-center>
											<v-flex v-if="$vuetify.breakpoint.smAndUp" shrink ml-7 class="d-flex mt-1">
												<v-layout column style="font-size: 18px">
													<v-flex class="mr-4" style="text-align: right">
														ชื่อไทย:
													</v-flex>
													<v-flex class="mr-4" style="text-align: right">
														ชื่ออังกฤษ :
													</v-flex>
													<v-flex class="mr-4" style="text-align: right">
														กลุ่มหลักสิ่งอุปกรณ์ :
													</v-flex>
													<v-flex class="mr-4" style="text-align: right">
														อุปกรณ์กลุ่มย่อยของอุปกรณ์ :
													</v-flex>
													<v-flex class="mr-4" style="text-align: right">
														เลขที่สิ่งอุปกรณ์ :
													</v-flex>
													<v-flex class="mr-4" style="text-align: right">
														หมายเลข สป. :
													</v-flex>
													<v-flex class="mr-4" style="text-align: right">
														ปีที่จัดทำ :
													</v-flex>
												</v-layout>
											</v-flex>

											<v-flex md5>
												<v-layout column>
													<v-flex>
														<v-text-field
															:label="$vuetify.breakpoint.smAndDown ? 'ชื่อไทย':''"
															background-color="#E5E5E5"
															v-model="medSearch.name_th"
															item-color="#84A2A8"
															solo
															required>
														</v-text-field>
													</v-flex>
													<v-flex>
														<v-text-field
															:label="$vuetify.breakpoint.smAndDown ? 'ชื่ออังกฤษ':''"
															background-color="#E5E5E5"
															item-color="#84A2A8"
															v-model="medSearch.name_en"
															solo
															required>
														</v-text-field>
													</v-flex>
													<v-flex>
														<multiselect
															:options="medGroups"
															v-model="medSearch.main_group"
															placeholder="กลุ่มหลักสิ่งอุปกรณ์"
															label="main_group_desc"
															track-by="group_main"
															@input="onSelectMedGroup"
														></multiselect>
<!--														<v-select-->
<!--																:options="medGroups"-->
<!--																v-model="medSearch.main_group"-->
<!--																placeholder="กลุ่มหลักสิ่งอุปกรณ์"-->
<!--																label="main_group_desc"-->
<!--																track-by="group_main"-->
<!--																@select="onSelectMedGroup"-->
<!--														></v-select>-->
													</v-flex>
													<v-flex>
														<multiselect
															:options="medSubGroups"
															v-model="medSearch.sub_group"
															placeholder="อุปกรณ์กลุ่มย่อยของอุปกรณ์"
															label="sub_group1_desc"
															track-by="sub_group1">
														</multiselect>
													</v-flex>
													<v-flex>
														<v-text-field
															:label="$vuetify.breakpoint.smAndDown ? 'เลขที่สิ่งอุปกรณ์':''"
															min="0"
															background-color="#E5E5E5"
															item-color="#84A2A8"
															v-model="medSearch.spec_no"
															solo
															required>
														</v-text-field>
													</v-flex>
													<v-flex>
														<v-text-field
															:label="$vuetify.breakpoint.smAndDown ? 'หมายเลข สป.':''"
															min="0"
															background-color="#E5E5E5"
															item-color="#84A2A8"
															v-model="medSearch.spec_code"
															solo
															required>
														</v-text-field>
													</v-flex>
													<v-flex>
<!--														<v-text-field-->
<!--															:label="$vuetify.breakpoint.smAndDown ? 'ปีที่จัดทำ':''"-->
<!--															min="0"-->
<!--															item-color="#84A2A8"-->
<!--															type="number"-->
<!--															background-color="#E5E5E5"-->
<!--															v-model="medSearch.year"-->
<!--															solo-->
<!--															required>-->
<!--														</v-text-field>-->
														<multiselect
																label="year"
																track-by="year"
																:options="yearList"
																v-model="medSearch.year"
																placeholder="ปีที่จัดทำ">
														</multiselect>
<!--														<v-select-->
<!--																:items="years"-->
<!--																:label="$vuetify.breakpoint.smAndDown ? 'ปีที่จัดทำ':''"-->
<!--																item-color="#84A2A8"-->
<!--																background-color="#E5E5E5"-->
<!--																v-model="medSearch.year"-->
<!--																solo-->
<!--																required-->
<!--																clearable-->
<!--														></v-select>-->

													</v-flex>
												</v-layout>
											</v-flex>
										</v-layout>
									</v-form>
								</div>
							</v-flex>
						</v-layout>
					</v-card>
				</v-flex>
			</v-layout>
			<v-layout class="form-search mb-12" justify-center>
				<v-flex mx-3 style="text-align: right">
					<v-btn
						style="background-color: #527281; color: white;border-radius: 25px;width: 150px;font-size: 18px"
						@click="search()">
						<span>ค้นหา</span>
					</v-btn>
				</v-flex>
				<v-flex mx-3 style="text-align: left">
					<v-btn
						style="background-color: #BDBDBD; color: white;border-radius: 25px;width: 150px;font-size: 18px"
						@click="clear()">
						<span>ล้างการค้นหา</span>
					</v-btn>
				</v-flex>
			</v-layout>
		</v-container>

		<!-- Table Form -->
		<v-layout style="background-color: white;" v-if="showTable">
			<v-flex class="mt-4">
				<v-layout>
					<v-flex class="ml-12" style="text-align: left; font-size: 32px;">
						ผลการค้นหา : {{ meds.total }} รายการ
					</v-flex>
				</v-layout>
				<v-layout justify-center class="table-search">
					<v-flex shrink xs10 md12 class="mx-12 my-2 mb-12">
						<v-card>
							<template>
<!--								:items="meds"-->
								<v-data-table
									:mobile-breakpoint="600"
									:headers="headers"
									:items="meds.data"
									:hide-default-footer="true"
								>
									<template v-slot:item.group_num="{ item }">
										<v-flex ml-4 style="text-align: left;">
											{{findMeds(item)}}
										</v-flex>
									</template>
									<template v-slot:item.name_th="{ item }">
										<v-flex ml-4 style="text-align: left;">
											{{item.name_th}}
										</v-flex>
									</template>
									<template v-slot:item.name_en="{ item }">
										<v-flex ml-4 style="text-align: left;">
											{{item.name_en}}
										</v-flex>
									</template>
									<template v-slot:item.unit="{ item }">
										<v-flex style="text-align: center;">
											{{item.unit ? item.unit : "-"}}
										</v-flex>
									</template>
									<template v-slot:item.showData="{ item }">
										<router-link
												:to="{ name: 'show-detail', query: { id: item.id }}"
												target="_blank"
												style="text-decoration: none"
										>
											<v-icon style="color: #D97C57">search</v-icon>
										</router-link>
									</template>
									<!-- สั่งพิมพ์เพื่อจัดหา -->
									<template v-slot:item.printBuyPDF="{ item }">
										<v-icon v-if="item.path_file" style="color: #D97C57;cursor: pointer" @click="getOrder(item.id)">attach_file</v-icon>
										<span v-else="item.path_file">-</span>
									</template>
									<!-- สั่งพิมพ์เพื่อดู -->
									<template v-slot:item.printViewPDF="{ item }">
										<v-icon v-if="item.path_file" style="color: #D97C57;cursor: pointer" @click="getView(item.id)">attach_file</v-icon>
										<span v-else="item.path_file">-</span>
									</template>
								</v-data-table>

								<loading
										color="#527281"
										:active.sync="isLoading"
										:can-cancel="false"
										:is-full-page="fullPage"
								></loading>

							</template>
						</v-card>
					</v-flex>
				</v-layout>
				<v-layout>
					<v-flex>
						<v-pagination
								:length="pagination.last_page"
								:total-visible="9"
								v-model="pagination.current_page"
								@input="getPagination"
						></v-pagination>
					</v-flex>
				</v-layout>
			</v-flex>

		</v-layout>
		<v-layout>
			<v-flex class="py-6" style="background-color: white">
			</v-flex>
		</v-layout>


		<!-- Footer -->
		<Footer></Footer>
	</v-content>
</template>

<script>
	import Header from "../components/Header"
	import Footer from "../components/Footer"
	import { mapState, mapActions } from "vuex";
	import Login from "./Login";
	import { domain } from "../util/Constants"
	import Loading from 'vue-loading-overlay';
	import 'vue-loading-overlay/dist/vue-loading.css';

  	export default {
    	name: "HomeSearch",

		components: {
		  Footer,
		  Header,
		  Loading
		},

		data: () => ({
			isLoading: false,
            fullPage: true,
			yearList: [],
			showTable: false,
			headers: [
				{text: 'เลขที่ สป.', value: 'spec_no', sortable: true, align: 'center', width: "1%"},
				{text: 'หมายเลข สป.', value: 'spec_code', sortable: true, align: 'center', width: "3%"},
				{text: 'ชื่อ สป. (ไทย)', value: 'name_th', sortable: true, align: 'center', width: "8%"},
				{text: 'ชื่อ สป. (อังกฤษ)', value: 'name_en', sortable: true, align: 'center', width: "8%"},
				{text: 'หน่วยนับ', value: 'unit', sortable: true, align: 'center', width: "3%"},
				// {text: 'อุปกรณ์กลุ่มย่อยของอุปกรณ์', value: 'group_num', sortable: true, align: 'center', width: "10%"},
				{text: 'ปีที่จัดทำ', value: 'year', sortable: true, align: 'center', width: "2%"},
				{text: 'ประเภท', value: 'type_spec', sortable: true, align: 'center', width: "1%"},
				// {text: 'GPSC', value: 'gpsc', sortable: true, align: 'center', width: "1%"},
				{text: 'ดูเนื้อหา คฉ.', value: 'showData', sortable: true, align: 'center', width: "2%"},
				{text: 'สั่งพิมพ์เพื่อจัดหา', value: 'printBuyPDF', sortable: true, align: 'center', width: "3%"},
				{text: 'สั่งพิมพ์เพื่อดู', value: 'printViewPDF', sortable: true, align: 'center', width: "3%"},
			],
			form: {
				meds: '',
			}
		}),
		computed: {
			// years () {
			// 	this.year = new Date().getFullYear()
			// 	return Array.from({length: this.year - 1900 }, (value, index) => (1901+543) + index).reverse()
			// },
    		// Map Vuex state.
		  ...mapState({
			medSearch: state => {
				return state.Med.medSearch
			},
			meds: state => {
				return state.Med.meds
			},
			pagination: state => {
				return state.Med.pagination
			},
			medGroups: state => {
				return state.MedGroup.medGroups
			},
			medSubGroups: state => {
				return state.MedGroup.medSubGroups
			},
			user: state => {
				return state.Auth.user;
			},
			  yearsList: state => {
				return state.Common.select_years;
			},

		  })
		},
	  // mounted() {
		//   console.log(this.medGroups)
	  // },
		created () {
			this.isLoading = true;
			this.getYear();
			setTimeout(() => {
				   this.getAllMedGroups();
				   this.isLoading = false;
			})
			this.showTable = true;
			this.searchMeds({
				   user_id: this.user.id,
				   paginate: this.pagination.current_page,
			});
			this.clear();
			this.setData();
		},
		methods: {
		  	...mapActions('Med', [
				'searchMeds',
				'getYear'
		  	]),
		  	...mapActions('MedGroup', [
			  	'getMedGroups',
			  	'getMedSubGroups',
			  	'getAllMedGroups'
		  	]),
			getYear() {
				this.$store.dispatch("Common/getYear").then(res => {
					this.yearList = res;
				})
			},
			setData() {
				this.meds.data.forEach(data => {
					if (data.spec_group.group_level === '1') {
						this.form.meds = data.spec_group.main_group_desc;
					}else if (data.spec_group.group_level === '2') {
						this.form.meds = data.spec_group.main_group_desc;
					}else if (data.spec_group.group_level === '3') {

					}else if (data.spec_group.group_level === '4') {

					}else {
						console.log(0)
					}
				})
			},
			search() {
				if(!this.medSearch.name_th &&
						!this.medSearch.name_en &&
						!this.medSearch.main_group &&
						!this.medSearch.sub_group &&
						!this.medSearch.spec_no &&
						!this.medSearch.spec_code &&
						!this.medSearch.year) {
					alert('กรุณากรอกคำค้นหา...')
				} else {
					this.isLoading = true;
					this.$store.dispatch("Med/clearSearch");
					let data = {
						user_id: this.user.id,
						paginate: this.pagination.current_page,
					}
					this.$store.dispatch('Med/searchMeds', data).then(res => {
						this.isLoading = false;
					})
					// console.log(this.pagination)
					// this.searchMeds(this.user.id,this.pagination.current_page)
				}
		  	},
			getOrderPdf(id) {
				this.isLoading = true;
				window.open(domain+`/get-order-pdf/${id}?user_id=${this.user.id}`);
				// window.open(domain+'/get-order-pdf/'+id);
				this.isLoading = false;
			},
			getViewPdf(id) {
				this.isLoading = true;
				window.open(domain+'/get-view-pdf/'+id);
				this.isLoading = false;
			},

			onSelectMedGroup (val) {
				this.medSearch.sub_group = null
				// this.$store.dispatch("MedGroup/clearMedSubGroup");
				// this.clearMedSubGroup();
				this.getMedSubGroups(val.group_main)
			},

			getOrder(id) {
				this.isLoading = true;
				this.$store.dispatch('Med/getMed', id).then(data => {
					console.log('getOrder', data)
					let data_order = {
						group_num: data.group_num,
						medspec_id: data.id,
						year: data.year,
						print_type: '2',
						user_id: this.user.id,
						status: data.status,
					};
					this.$store.dispatch('Common/saveOrder', data_order).then(data => {
						this.isLoading = false;
						this.getOrderPdf(id);
					})
				})
			},
			getView(id) {
				this.isLoading = true;
				this.$store.dispatch('Med/getMed', id).then(data => {
					let data_order = {
						group_num: data.group_num,
						medspec_id: data.id,
						year: data.year,
						print_type: '1',
						user_id: this.user.id,
						status: data.status,
					};
					this.$store.dispatch('Common/saveViewOrder', data_order).then(data => {
						this.isLoading = false;
						this.getViewPdf(id);
					})
				})
			},
			clear() {
				this.isLoading = true;
				this.$store.dispatch("MedGroup/clearMedSubGroup");
				this.$store.dispatch("Med/clear");
				this.isLoading = false;
			},

			// Pagination
			getPagination(page) {
				// console.log(page)
				let data = {
					user_id: this.user.id,
					paginate: page,
				}
				this.$store.dispatch('Med/searchMeds', data)

			},
			findMeds(data) {
				try {
					const level = parseInt(data.spec_group.group_level);
					if(level > 1) {
						return data.spec_group[`sub_group${level-1}_desc`]
					} else {
						return "-"
					}
				} catch(e) {
					return "-"
				}
			}
    	}
  }


</script>

<style lang="scss">
	.form-search {
		.v-text-field.v-text-field--solo .v-input__control {
			min-height: 35px !important;
		}

		.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
			border-radius: 20px;
			box-shadow: unset;
		}

		.theme--light.v-input:not(.v-input--is-disabled) input, .theme--light.v-input:not(.v-input--is-disabled) textarea {
			color: #527281;
		}

		.theme--light.v-select .v-select__selections {
			color: #527281;
		}

		.theme--light.v-select:hover {
			color: #527281;
		}

		.v-icon.v-icon {
			color: #527281 !important;
			caret-color: #527281 !important;
		}

		.v-text-field.v-text-field--enclosed .v-text-field__details {
			margin-bottom: 0;
		}

		.v-input__slot {
			margin-bottom: 0;
		}

		.v-menu__content.theme--light.menuable__content__active {
			text-align: left !important;
		}
	}

	.table-search {
		.text-left {
			text-align: left;
		}
	}

	th.text-center {
		background: #527281;
		color: white !important;
		font-size: 14px !important;
	}

	th.text-center:not(:last-child) {
		border-right-style: solid;
		border-color: white;
		border-width: 1px;
	}

	.v-data-table td, .v-data-table th {
		padding: 0 4px !important;
	}

	.multiselect {
		margin-bottom: 14px;
		.multiselect__tags {
			height: 32px;
			border-radius: 20px;
			background-color: #E5E5E5;
			color: #84A2A8;
			.multiselect__input, .multiselect__single {
				background-color: #E5E5E5;
			}
		}
		.multiselect__content {
			padding-left: 0;
		}
	}
</style>
